import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { DhlFormControlTable } from '../../models/dhl-form-control-table';

@Component({
    selector: 'app-form-field-table',
    templateUrl: './form-field-table.component.html',
    styleUrls: ['./form-field-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldTableComponent implements OnInit, OnChanges {
  @Input() configData: DhlFormControlTable;
  @Input() frmGroup: UntypedFormGroup;    

  constructor(private formBuilder: UntypedFormBuilder) { }

  allowedLine: boolean = true;    

  ngOnChanges(changes: SimpleChanges ) {
    if(changes['isDeleteButton']){  
      this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
    }
  }

  ngOnInit() {        
    console.log(this.frmGroup);
    console.log(this.configData);
    localStorage.removeItem('poLine');

    let page = localStorage.getItem('templateName');
    this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = true;
    this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = true;
    
    this.configData.validation.forEach((data)=>{      

      if(data === 'OneOrMoreLines' && this.frmGroup.get(this.configData.name)['controls'].length < 2){
        this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
      }
      if(data === 'optional' && this.frmGroup.get(this.configData.name)['controls'].length < 2){
        this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
        this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = false;        
      }
    }, this);
  }

  getFormTableControls(){
    return this.frmGroup.controls[this.configData.name]['controls'];                
  }  
  
  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for ( let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    return colsClass;
  }

  addItem(e) {
    e.preventDefault();            
    let grp ={};

    this.configData.controls.forEach((field)=>{
      grp[field.name] = field.required === true ? new UntypedFormControl
                (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, 
                    [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) : 
                        new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, 
                            Validators.maxLength(parseInt(field['maxLength'])));
    });
     
    (<UntypedFormArray>this.frmGroup.controls[this.configData.name]).push(new UntypedFormGroup(grp));      
    this.allowedLine = true;    
    this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = true;

    // this.configData.validation.forEach(elem=>{
    //   let check = elem.split('-');
      // if(check[0] === 'storage'){
      //   localStorage.setItem(check[1], (<FormArray>this.frmGroup.controls[this.configData.name]).length.toString())
      // }
    // })
  }
  
  deleteItem( e, index: number) {    
    e.preventDefault();    
    let count = 0;    

    // if(localStorage.getItem('poLineIdToBeExcluded') !== null){
    //   if(JSON.parse(localStorage.getItem('poLineIdToBeExcluded')).length === 1){
    //     localStorage.removeItem('poSourceId');
    //     localStorage.removeItem('poDestId');
    //     localStorage.removeItem('poLineIdToBeExcluded');
        
    //     this.frmGroup.controls[this.configData.name].parent.controls['source'].setValue("");    
    //     this.frmGroup.controls[this.configData.name].parent.controls['destination'].setValue("");

    //   } 
      // else{      
      //   let poLines =  JSON.parse(localStorage.getItem('poLineIdToBeExcluded'));
      //   poLines.splice(index, 1);
      //   localStorage.setItem('poLineIdToBeExcluded', JSON.stringify(poLines));
      // }  
    // }     

    (<UntypedFormArray>this.frmGroup.controls[this.configData.name]).removeAt(index);
    this.frmGroup.markAsTouched();    
    this.configData.validation.forEach((elem)=>{
      if(elem === "OneOrMoreLines"){
        if((<UntypedFormArray>this.frmGroup.controls[this.configData.name]).length === 1){
          this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
        }
      }
      (<UntypedFormArray>this.frmGroup.controls[this.configData.name])
      // let check = elem.split('-');
      // if(check[0] === 'remove'){        
      //   let totalQtyRelease;
      //   let qtyRelease = this.frmGroup.controls[this.configData.name]['controls'][index].value[check[1]];
      //   totalQtyRelease = localStorage.getItem(check[1]);
      //   totalQtyRelease = parseInt(totalQtyRelease) - parseInt(qtyRelease);
      //   localStorage.setItem(check[1], totalQtyRelease.toString());
      // }
    }, this);  
    this.frmGroup.controls[this.configData.name].value.forEach((line, idx)=>{
      if(line.poLineItemId1){
        count++;          
      }
    })
    if(count == 0){
      localStorage.removeItem('poSourceId');
      localStorage.removeItem('poDestId');
      this.frmGroup.controls[this.configData.name].parent.controls['source'].setValue("");    
      this.frmGroup.controls[this.configData.name].parent.controls['destination'].setValue("");
    }    
  }
}
